"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CleanJson_1 = __importDefault(require("CleanJson/CleanJson"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var EditActionBar_1 = __importDefault(require("./EditActionBar/EditActionBar"));
var EditActionBarStore_1 = __importDefault(require("./EditActionBar/EditActionBarStore"));
var react_1 = __importDefault(require("react"));
var OverlayMode_1 = require("OverlayStack/OverlayMode");
var mobx_1 = require("mobx");
var SaveOrchestrator_1 = require("./SaveOrchestrator");
module.exports = function (createUi, blockBuilder, block, origin, overlayStack, showDeleteModal, mountReactComponent, telemetry, rolesService, user, savedBlockService, isNewSavedBlock, $timeout, projectDimensionStore) {
    var workingBlock = (0, mobx_1.toJS)(block);
    workingBlock.$isSavedBlock = true;
    var menuActions = require("Project/BlockNew/Menu/NavigatorActions");
    var blockUi = blockBuilder({
        block: workingBlock,
        autoPersist: false,
        blockMenuActions: menuActions,
    });
    workingBlock.$ctrl = blockUi;
    var saveOrchestrator = new SaveOrchestrator_1.SaveOrchestrator(workingBlock, isNewSavedBlock, savedBlockService, telemetry, origin);
    var editActionBarStore = new EditActionBarStore_1.default(workingBlock, savedBlockService, saveOrchestrator, overlayStack);
    var onClose = function () { return __awaiter(void 0, void 0, Promise, function () {
        var title, explainer, confirmLeaveWithoutSaving;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!editActionBarStore.hasUnsavedChanges) return [3, 2];
                    title = saveOrchestrator.requiresInitialSave ? "Delete this block?" : "Discard changes?";
                    explainer = saveOrchestrator.requiresInitialSave
                        ? "This block hasn't been saved. You will lose this block if you leave without saving."
                        : "You have unsaved changes to this block. Changes will be discarded if you leave without saving.";
                    return [4, showDeleteModal({
                            title: title,
                            explainer: explainer,
                            deleteButton: saveOrchestrator.requiresInitialSave ? "Delete" : "Discard",
                        })];
                case 1:
                    confirmLeaveWithoutSaving = _a.sent();
                    if (confirmLeaveWithoutSaving) {
                        $timeout(overlayStack.closeCurrent);
                    }
                    return [3, 3];
                case 2:
                    $timeout(overlayStack.closeCurrent);
                    _a.label = 3;
                case 3: return [2];
            }
        });
    }); };
    var userIsAdmin = rolesService.isAdmin(user);
    var ui = createUi(require("./ContentEditor.html"), {
        block: workingBlock,
        theBlock: blockUi.ui,
        actionBar: mountReactComponent(react_1.default.createElement(EditActionBar_1.default, { userIsAdmin: userIsAdmin, editActionBarStore: editActionBarStore, onCloseClick: onClose })),
        $init: function (scope) {
            var getBlockStateString = function () {
                return JSON.stringify((0, CleanJson_1.default)(scope.$eval("ui.block")));
            };
            var initialBlockState = getBlockStateString();
            var update = function () {
                if (getBlockStateString() === initialBlockState) {
                    return;
                }
                if (saveOrchestrator.shouldIgnoreUpdate) {
                    saveOrchestrator.shouldIgnoreUpdate = false;
                    return;
                }
                editActionBarStore.hasUnsavedChanges = true;
            };
            var debounced = (0, debounce_1.default)(update, 100, {
                trailing: true,
                leading: false,
            });
            scope.$watch(function () {
                return JSON.stringify((0, CleanJson_1.default)(scope.$eval("ui.block")));
            }, debounced, true);
        },
        $onElementRendered: function (measurableBlockElemWrapper) {
            var measurableBlockElem = measurableBlockElemWrapper[0];
            if (typeof ResizeObserver !== "undefined") {
                var handleResizeBlockElem = function (entries) {
                    if (entries.length > 0) {
                        var width = entries[0].contentBoxSize[0].inlineSize;
                        measurableBlockElem.style.setProperty("--page-content-width", "".concat(width, "px"));
                        projectDimensionStore.pageContentWidth = width;
                    }
                };
                var resizeObserver_1 = new ResizeObserver(handleResizeBlockElem);
                resizeObserver_1.observe(measurableBlockElem);
                measurableBlockElemWrapper.on("$destroy", function () {
                    resizeObserver_1.unobserve(measurableBlockElem);
                });
            }
        },
    });
    overlayStack.add({
        contentUi: ui,
        options: {
            overlayMode: OverlayMode_1.OverlayMode.Modal,
            confirmClose: onClose,
        },
    });
    overlayStack.usingCustomCloseButton();
};
